import styled, { css } from 'styled-components';
import { StyledLabelProps } from './types';

export const Label = styled.label<StyledLabelProps>`
  color: ${({ theme }) => theme.color.text.neutral.strong};

  ${({ $disabled }) =>
    $disabled &&
    css`
      color: ${({ theme }) => theme.color.text.neutral.weak};
    `}

  ${({ $error }) =>
    $error &&
    css`
      color: ${({ theme }) => theme.color.text.danger.default};
    `}

  font-weight: ${({ theme }) => theme.font.weight.bold};
  font-size: ${({ theme }) => theme.font.size.m3};
  display: flex;

  svg {
    margin: ${({ theme }) => theme.spacing.km0}
      ${({ theme }) => theme.spacing.km1};
  }
`;
